import React, { useState } from 'react'
import cx from 'classnames'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { toggleSidebar } from 'common/core/actions/uiActions'
import { useSidebarAccountList } from 'common/core/coreHooks'
import { getIsSidebarHidden } from 'common/core/selectors/uiSelectors'
import { useMediaQuery } from 'utils/commonHooks'
import { analyticsService } from 'utils/services/analytics'

import { Layout } from '../Layout/Layout'

import { Sidebar } from './Sidebar/Sidebar'

import cm from './LayoutWithSidebar.module.css'

export const LayoutWithSidebar = () => {
  const dispatch = useAppDispatch()
  const isMobile = useMediaQuery('(max-width: 900px)')

  const [accountsListOpen, setAccountsListOpen] = useState(false)
  const isSidebarHidden = useAppSelector(getIsSidebarHidden)

  const { isFetching, accountList } = useSidebarAccountList(accountsListOpen)

  const handleToggleSidebar = () => {
    analyticsService.sendEvent(isSidebarHidden ? 'SIDEBAR.OPEN' : 'SIDEBAR.HIDE', {
      windowWidth: window.innerWidth,
    })

    dispatch(toggleSidebar())
  }

  const handleSidebarBackdropClick: React.MouseEventHandler<HTMLDivElement> = (event) => {
    const isBackdropClick = event.target === event.currentTarget
    if (isBackdropClick && isMobile) {
      dispatch(toggleSidebar())
    }
  }

  return (
    <Layout>
      <div
        className={cx(cm.sidebar, {
          [cm.sidebarHidden]: isSidebarHidden,
          [cm.open]: !isSidebarHidden,
        })}
        onClick={handleSidebarBackdropClick}
      >
        <Sidebar
          accounts={accountList}
          isSidebarHidden={isSidebarHidden}
          onToggleSidebar={handleToggleSidebar}
          onSelectAccountClick={() => setAccountsListOpen(true)}
          isLoading={isFetching}
        />
      </div>
    </Layout>
  )
}
